import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  cookieValue = 'UNKNOWN';

  constructor(private _cookie: CookieService) { }

  isLoggedIn() {
    let portal = this._cookie.get('portal');
    if (portal !== '') {
      return true;
    };
    return false;
  };
}